import { lookupZipCode } from "@/infrastructure/services/profileService";
import { useCallback, useState } from "react";

export function useZipCode() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const searchZipCode = useCallback(async (zipCode: string) => {
    setIsLoading(true); setError("");
    try { return await lookupZipCode(zipCode); }
    catch (requestError) { const message = requestError instanceof Error ? requestError.message : "CEP não encontrado."; setError(message); throw requestError; }
    finally { setIsLoading(false); }
  }, []);
  return { error, isLoading, searchZipCode, setError };
}
